import SynopNotification from './SynopNotification';

/**
 * Договор для синоптики
 */
export default class SynopContract {
  constructor() {
    this.id = '';
    this.user_id = '';
    this.name = '';
    this.status = 0;
    this.up_time = new Date().toISOString().substr(0, 10),
      this.create_date = new Date().toISOString().substr(0, 10),
      this.expiration_date = new Date().toISOString().substr(0, 10),
      this.radius = 0.0;
    this.max_request_count_day = 0;
    this.is_strict_restriction = false;
    this.emails = [];
    this.notification = new SynopNotification();
  }
}